/**
 * The conversation the user is currently viewing, set by the Chat page on
 * mount / target change and cleared on unmount. The realtime provider reads
 * it (outside React, on every push) to suppress a redundant toast for a
 * message that lands in the conversation already on screen.
 *
 * Module-level singleton on purpose: there is only ever one Chat page, and
 * the provider needs a synchronous read without prop-drilling through the
 * socket callback.
 */
let active: string | null = null;

export function setActiveChatConversation(key: string | null): void {
  active = key;
}

export function getActiveChatConversation(): string | null {
  return active;
}
